module.exports = __webpack_public_path__ + "images/366bc9d5ae979a56702d7275f0d8be2a-Motion3.0_(Alula)_line_art_200x200.png";